import { Button, ButtonText } from '@/components/ui/button'
import { Center } from '@/components/ui/center'
import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { UsersIcon } from 'lucide-react-native'
import { useRouter } from 'expo-router'
import { View } from 'react-native'

export default function OutOfUsersQuota() {
  const router = useRouter()
  const [systemOrange, secondaryLabel] = usePlatformColor('systemOrange', 'secondaryLabel')

  return (
    <Center className="flex-1 px-10">
      <VStack space="md" className="items-center">
        <View className="w-20 h-20 rounded-full bg-orange-100 dark:bg-orange-900/30 items-center justify-center mb-2">
          <UsersIcon size={40} color={systemOrange as string} />
        </View>
        <Text size="xl" className="font-semibold">
          企业成员超出上限
        </Text>
        <Text size="md" style={{ color: secondaryLabel }} className="text-center">
          该企业成员使用超出上限，请联系账号管理员
        </Text>
      </VStack>
      <Button size="lg" variant="outline" className="w-full max-w-sm mt-10" onPress={() => router.replace('/profile/switchUser')}>
        <ButtonText>切换账号</ButtonText>
      </Button>
    </Center>
  )
}
